import PropTypes from 'prop-types';
import classNames from "classnames";
import { markdownToHtml } from "../markdown/conversions";

import styles from './styles/Markdown.module.scss';
import {useContext} from "react";
import {StoreContext} from "../../stores/StoreLoader";



export default function Markdown({withStyles, source, ...restProps}) {
    const {interfaceStore} = useContext(StoreContext);
    const markdownClassname = classNames({
        [styles.markdown]: withStyles === true,
    });

    const contents = markdownToHtml(source, interfaceStore.currentFullUrl);

    return <div className={markdownClassname} {...restProps} dangerouslySetInnerHTML={{__html: contents}} />
}

Markdown.defaultProps = {
    withStyles: false,
};

Markdown.propTypes = {
    withStyles: PropTypes.bool,
    source: PropTypes.string,
};

